export default {
	maxDateMessage: "La fecha no debe ser posterior a la fecha máxima.",
	minDateMessage: "La fecha no debe ser anterior a la fecha mínima.",
}